import {connect} from 'react-redux';

import {ContentPartners, setContentPartnersAction} from '@pluto/content-partners';
import {ContentTypes} from '@pluto/content-types';
import {setQcJobsStatusesAction} from '@pluto/qc-jobs-statuses';
import {setUsersAction, UsersState} from '@pluto/users';
import DeliveryManagerFiltersContainer from './DeliveryManagerFiltersContainer';
import {enumMapper} from '../../../ContentItem/Search/Redux/SearchSelectors';

export interface State {
    contentPartners: ContentPartners;
    contentTypes: ContentTypes;
    users: UsersState;
    textEnums: {
        deliveryJobStatuses: {[key: string]: string},
        searchableContentItemTypes: {[key: string]: string};
    };
}

export const mapState = (state: State) => {
    const {
        contentPartners,
        users,
        textEnums: {
            searchableContentItemTypes = {},
            deliveryJobStatuses = {},
        }
    } = state;

    return {
        contentPartners,
        users,
        qcJobsStatuses: {
            statuses: Object.entries(deliveryJobStatuses).map(
                enumMapper
            ),
            isLoading: false,
        },
        contentTypes: {
            data: Object.entries(searchableContentItemTypes).map(
                enumMapper
            ),
            isLoading: false,
        },
    };
};

export const mapDispatch = {
    setContentPartners: setContentPartnersAction,
    setUsers: setUsersAction,
    setQCStatuses: setQcJobsStatusesAction,
};

export default connect(mapState, mapDispatch)(DeliveryManagerFiltersContainer);
